(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/utils.js');
"use strict";


const _svs$components$sport = svs.components.sport.tipsenShared,
  buttonChoices = _svs$components$sport.buttonChoices,
  signIndexToOutcome = _svs$components$sport.signIndexToOutcome;
const wagerSystemTypes = svs.components.tipsen.engine.constants.wagerSystemTypes;
const _svs$components$sport2 = svs.components.sportinfo.common.constants,
  EventTypeField = _svs$components$sport2.EventTypeField,
  EventTypeDistributionsFallback = _svs$components$sport2.EventTypeDistributionsFallback,
  EventTypeId = _svs$components$sport2.EventTypeId;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const getIsDistributionDisplay = selectedCouponChoice => selectedCouponChoice === buttonChoices.PEOPLE_DISTRIBUTION || selectedCouponChoice === buttonChoices.SYSTEM_DISTRIBUTION;
const getShouldShowInit = _ref => {
  let isCompressed = _ref.isCompressed,
    isGoalCount = _ref.isGoalCount,
    isSmall = _ref.isSmall,
    selectedCouponChoice = _ref.selectedCouponChoice;
  let shouldShowInit = false;
  if (!isGoalCount) {
    shouldShowInit = true;
  } else {
    shouldShowInit = !(isGoalCount && isCompressed && isSmall && getIsDistributionDisplay(selectedCouponChoice));
  }
  return shouldShowInit;
};
const getShouldShowCheckmark = _ref2 => {
  let systemType = _ref2.systemType,
    isResult = _ref2.isResult,
    isGoalCount = _ref2.isGoalCount,
    isCompressed = _ref2.isCompressed;
  return systemType === wagerSystemTypes.MSYS && !isResult && !isGoalCount && !isCompressed;
};
const getShouldShowTeamNames = _ref3 => {
  let selectedCouponChoice = _ref3.selectedCouponChoice,
    isCompressed = _ref3.isCompressed;
  return selectedCouponChoice === buttonChoices.GAMES || !isCompressed;
};
const getProductDistribution = _ref4 => {
  var _eventStatistics$Even;
  let eventStatistics = _ref4.eventStatistics,
    productId = _ref4.productId,
    drawNumber = _ref4.drawNumber;
  let productDistribution = [];
  if (eventStatistics !== null && eventStatistics !== void 0 && (_eventStatistics$Even = eventStatistics[EventTypeField.Distributions]) !== null && _eventStatistics$Even !== void 0 && _eventStatistics$Even[productId]) {
    productDistribution = (eventStatistics[EventTypeField.Distributions][productId][drawNumber] ? eventStatistics[EventTypeField.Distributions][productId][drawNumber] : eventStatistics[EventTypeField.Distributions][productId][EventTypeDistributionsFallback] 
    ) || [];
  }
  return productDistribution;
};
const getEventCommentForCancelledGame = _ref5 => {
  let resultForCurrentEvent = _ref5.resultForCurrentEvent,
    productId = _ref5.productId;
  const eventTypeId = getDefinitionByProduct(productId).outcomes.eventTypeId;
  const isGoalCount = eventTypeId === EventTypeId.GOAL_COUNT;
  const index2Sign = signIndexToOutcome[eventTypeId || 1];
  const outcome = resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.outcome;
  let prefix = '';
  if (!isGoalCount) {
    prefix = outcome === 1 ? 'ett' : 'en';
  }
  let formattedOutcome = '';
  if (isGoalCount) {
    const nrOfGoals = (resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.home) + (resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.away);
    formattedOutcome = "".concat(nrOfGoals, " m\xE5l");
  } else {
    const outcome = resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.outcome;
    const outcomeSign = index2Sign[resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.outcome];
    formattedOutcome = "".concat(outcomeSign, " ").concat(outcome !== 1 ? '\'a' : '');
  }
  return "Lottad till ".concat(prefix, " ").concat(formattedOutcome);
};
setGlobal('svs.components.tipsen.couponStatic.utils', {
  getEventCommentForCancelledGame,
  getIsDistributionDisplay,
  getProductDistribution,
  getShouldShowCheckmark,
  getShouldShowInit,
  getShouldShowTeamNames
});

 })(window);